<template src="./SideMenu.html"></template>

<script>
import { psoriasis as psoriasisSections } from '@/data/sections';
import { tremfya as tremfyaSections } from '@/data/sections';
import { mapState } from 'vuex';

export default {
  name: 'side-menu',
  data() {
    return {
      section: '',
      menuType: 'main'
    };
  },
  computed: {
    ...mapState(['userAgent']),
    currentSection() {
      return this.$store.state.currentSection;
    }
  },
  watch: {
    '$route.meta.page': function() {
      this.setCurrentPage();
    }
  },
  methods: {
    setSection(obj) {
      this.$store.commit('setRouteFromParams', {
        name: this.$route.meta.page,
        params: {
          ...obj
        }
      });
    },
    setCurrentPage() {
      if (this.$route.meta.page === 'Psoriasis') {
        this.section = psoriasisSections;
      } else if (this.$route.meta.page === 'Tremfya') {
        this.section = tremfyaSections;
      }
    }
  },
  mounted() {
    this.setCurrentPage();
  }
};
</script>

<style lang="scss" src="./SideMenu.scss">
</style>
